function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 56,
  r: 30
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M247 241.1l-3.9 15.4c-3.9 8-11.8 20.9-26.1 30.5-8.8 5.9-17.6 8.9-21 10-4.2 1.4-10.2 3.3-18 4-7.1.6-19 1.6-31-5-2.6-1.4-16.8-9.6-20.9-25.6-.8-3-1-5.5-1.1-7.4 7-26 14.1-51.9 21.1-77.9 4.1-16.3 6.1-27.2 6.1-32.6 0-9.3-4.7-13.9-14.2-13.9-6.5 0-18.2 1.9-35.1 5.6l2.6-10.1L212 107.7l-16.6 52.9-21.3 81.6c-3.3 12.8-5 20.9-5 24.5 0 7.2 4.3 10.7 12.9 10.7 14.5.1 36.1-12 65-36.3z"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320"
  }, props), _ref, _ref2);
}

export default SvgInfo;